import React, {useId} from "react";
import PropTypes from "prop-types";
import {UncontrolledTooltip} from "reactstrap";
import {FaQuestionCircle} from "react-icons/fa";

/** This component will display help icon.
 *  And tooltip with help text when hovered on help icon */

const HelpIcon = (props) => {
  const {target, text} = props;

  const uniqueId = useId().replace(/[^a-zA-Z0-9_-]/g, "");
  const customId = `${target.toLowerCase().replaceAll(" ", "-")}-${uniqueId}`;

  return (
    <React.Fragment>
      <FaQuestionCircle id={customId} className="float-right" />
      <UncontrolledTooltip target={customId} placement={"auto"}>
        {text}
      </UncontrolledTooltip>
    </React.Fragment>
  );
};

HelpIcon.propTypes = {
  /** Text to be displayed in tooltip */
  text: PropTypes.string.isRequired,
  /** id which will be used by ReactTooltip component */
  target: PropTypes.string.isRequired,
};

export default HelpIcon;
